import AdSlot from './components/AdSlot';
const ArticleBottomAds = () => {
    return (
        <div className="article_bottom_ads">
            <AdSlot
                slotKey="article_bottom_ad"
                containerClass="article_bottom_ad"
                className="article_bottom_ad_image"
                id="article_bottom_ad"
            />
        </div>
    );
};

const ArticleSideAds = () => {
    return (
        <AdSlot
            slotKey="article_side_ad"
            containerClass="article_side_ads"
            className="article_side_ad_image"
            id="article_side_ad"
        />
    );
};


export { ArticleBottomAds, ArticleSideAds };
